import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  endCapColors: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
